import React from 'react';
import { Box, Typography } from '@/shared/design-system/primitives';
import { AlertTriangle } from 'lucide-react';

interface WeightWarningBannerProps {
    isVisible: boolean;
}

/**
 * WeightWarningBanner: Tactical alert for missing physiological data.
 */
export const WeightWarningBanner: React.FC<WeightWarningBannerProps> = ({ isVisible }) => {
    if (!isVisible) return null;

    return (
        <Box style={{ 
            backgroundColor: 'rgba(239, 68, 68, 0.1)', 
            borderBottomWidth: 1, 
            borderBottomColor: 'rgba(239, 68, 68, 0.2)', 
            padding: 12, 
            flexDirection: 'row', 
            alignItems: 'center', 
            gap: 10 
        }}>
            <AlertTriangle size={16} color="#ef4444" />
            <Typography style={{ fontSize: 10, fontWeight: '800', color: '#ef4444', flex: 1 }}>
                PHYSIOLOGICAL DATA INCOMPLETE: No weight recorded. Baseline 85kg used for estimation. 
                Please update your Profile or use the Health app.
            </Typography>
        </Box>
    );
};
